module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.31023/js/img/commerceHubFeatures/icons-deal-tracking.svg"